import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom"; 
import "../scss/_aboutUs.scss";
import image2 from "../assets/researchAreas.JPG";
import image from "../assets/birthday_lab_photo.png";
import OurTeam from "../Components/OurTeam";

function AboutUs() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const animation = {
        initial: {
            opacity: 0,
            y: 100,
        },
        animate: {
            opacity: 1,
            y: 0,
        },
    };

    const handleJoinLabClick = () => {
        navigate("/Career");
    };

    return (
        <div className="about-container">
            <div className="about-us-first-page">
                <div className="empowering-text">
                    <h1>{t("about-us-title")}</h1>
                    <p>{t("about-us-description")}</p>
                    <motion.button
                        className="icon-btn"
                        whileHover={{ scale: 1.05 }}
                        onClick={handleJoinLabClick}
                    >
                        <div className="text">{t("join-the-lab")}</div>
                        <FontAwesomeIcon className="icon" icon={faArrowRight} />
                    </motion.button>
                </div>
                <img className="group-photo" src={image} alt="group" />
            </div>
            <div className="about-us-second-page">
                <div className="key-research-section">
                    <img
                        className="research-photo"
                        src={image2}
                        alt="research"
                    />
                    <div className="key-research-text">
                        <h1>{t("key-research-areas")}</h1>
                        <p>{t("key-research-description")}</p>
                    </div>
                </div>

                <div className="key-research-points">
                    <motion.div
                        className="research-point"
                        variants={animation}
                        initial="initial"
                        transition={{
                            delay: 0.45,
                        }}
                        whileInView="animate"
                        viewport={{
                            once: true,
                        }}
                    >
                        <div className="text">
                            <h1>{t("inclusive-technology-solutions")}</h1>
                            <p>{t("inclusive-description")}</p>
                        </div>
                        <FontAwesomeIcon
                            className="check-icon"
                            icon={faCheckCircle}
                        />
                    </motion.div>
                    <motion.div
                        className="research-point"
                        variants={animation}
                        initial="initial"
                        transition={{
                            delay: 0.45,
                        }}
                        whileInView="animate"
                        viewport={{
                            once: true,
                        }}
                    >
                        <div className="text">
                            <h1>{t("adaptive-learning-tools")}</h1>
                            <p>{t("adaptive-description")}</p>
                        </div>
                        <FontAwesomeIcon
                            className="check-icon"
                            icon={faCheckCircle}
                        />
                    </motion.div>
                    <motion.div
                        className="research-point"
                        variants={animation}
                        initial="initial"
                        transition={{
                            delay: 0.45,
                        }}
                        whileInView="animate"
                        viewport={{
                            once: true,
                        }}
                    >
                        <div className="text">
                            <h1>{t("sustainability-initiatives")}</h1>
                            <p>{t("sustainability-description")}</p>
                        </div>
                        <FontAwesomeIcon
                            className="check-icon"
                            icon={faCheckCircle}
                        />
                    </motion.div>
                    <motion.div
                        className="research-point"
                        variants={animation}
                        initial="initial"
                        transition={{
                            delay: 0.45,
                        }}
                        whileInView="animate"
                        viewport={{
                            once: true,
                        }}
                    >
                        <div className="text">
                            <h1>{t("community-driven")}</h1>
                            <p>{t("community-driven-description")}</p>
                        </div>
                        <FontAwesomeIcon
                            className="check-icon"
                            icon={faCheckCircle}
                        />
                    </motion.div>
                    <motion.div
                        className="research-point"
                        variants={animation}
                        initial="initial"
                        transition={{
                            delay: 0.45,
                        }}
                        whileInView="animate"
                        viewport={{
                            once: true,
                        }}
                    >
                        <div className="text">
                            <h1>{t("virtual-and-augmented")}</h1>
                            <p>{t("virtual-and-augmented-description")}</p>
                        </div>
                        <FontAwesomeIcon
                            className="check-icon"
                            icon={faCheckCircle}
                        />
                    </motion.div>
                    <motion.div
                        className="research-point"
                        variants={animation}
                        initial="initial"
                        transition={{
                            delay: 0.45,
                        }}
                        whileInView="animate"
                        viewport={{
                            once: true,
                        }}
                    >
                        <div className="text">
                            <h1>{t("education-and-support")}</h1>
                            <p>{t("education-and-support-description")}</p>
                        </div>
                        <FontAwesomeIcon
                            className="check-icon"
                            icon={faCheckCircle}
                        />
                    </motion.div>
                </div>
            </div>
            <div>
                <OurTeam />
            </div>
        </div>
    );
}

export default AboutUs;
